import { useMemo } from 'react';

import { BrandListProps } from '../types';
import styles from './LetterList.module.scss';
import LetterListDesktop from './LetterListDesktop';
import LetterListMobile from './LetterListMobile';

const LetterList = ({ brands }: BrandListProps) => {
    const firstLettersArr = useMemo(() => {
        const collator = new Intl.Collator();

        return Object.keys(brands).sort((a, b) => collator.compare(a, b));
    }, [brands]);

    return (
        <div>
            <div className={styles.desktop}>
                <LetterListDesktop firstLettersArr={firstLettersArr} />
            </div>
            <div className={styles.mobile}>
                <LetterListMobile firstLettersArr={firstLettersArr} />
            </div>
        </div>
    );
};

export default LetterList;
